export const orderByKeys = (state) => {
  const { allIds = [], byId } = state || {};
  return allIds.map((key) => byId[key]);
};

export const buildPriceKey = ({ componentKey, xKey, yKey }) => `${componentKey}_${xKey}_${yKey}`;
